import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

/**
 * 路由表，对应原项目 Next.js App Router 的三个页面。
 *
 * ⚠️ 必须用 history 模式，**不能用 hash 模式**：
 * E2EE 的口令是塞在 URL 的 `#` 后面的（`/rooms/xxx#passphrase`，见 lib/useSetupE2EE.ts），
 * 一旦路由占用 `#`，口令就永远取不到，加密会议会静默退化成普通会议。
 *
 * 代价是生产环境必须做 SPA fallback（未知路径回 index.html），
 * 这一步已在 server/index.mjs 里实现。
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/HomePage.vue'),
  },
  {
    path: '/rooms/:roomName',
    name: 'room',
    component: () => import('@/pages/RoomPage.vue'),
    props: true,
  },
  {
    // 邀约落地页（新增，React 对标项目没有）：受邀者从 /invite?code=xxx 进来，
    // 展示会议信息与链接状态后跳转 /rooms/<roomName>?invite=<code> 入会
    path: '/invite',
    name: 'invite',
    component: () => import('@/pages/InvitePage.vue'),
  },
  {
    path: '/custom',
    name: 'custom',
    component: () => import('@/pages/CustomPage.vue'),
  },
];

export default createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});
